import * as React from 'react'
import {
  List,
  TextField,
  Datagrid,
  NumberField,
  TextInput,
  useGetIdentity,
  TopToolbar,
  FilterButton,
  ExportButton,
  CreateButton,
  EditButton,
  BooleanField,
  DeleteWithConfirmButton,
} from 'react-admin'
import { useTranslate } from 'ra-core'

const FilesFilters = [<TextInput key="campaign_id" source="campaign_id" />]

const WsCampaignsListActions = () => {
  const translate = useTranslate()
  return (
    <TopToolbar>
      <CreateButton label={translate('surveys.actions.new_wscampaign')} />
      <FilterButton />
      <ExportButton />
    </TopToolbar>
  )
}

const WsCampaignList = props => {
  const { loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  return (
    <List
      {...props}
      actions={<WsCampaignsListActions />}
      bulkActionButtons={false}
      sort={{ field: 'id', order: 'ASC' }}
      filters={FilesFilters}
    >
      <Datagrid>
        <NumberField source="id" sortByOrder="DESC" />
        <TextField source="url_ws" />
        <NumberField source="campaign_id" />
        <BooleanField
          source="status"
          valueLabelTrue="Active"
          valueLabelFalse="Not Active"
        />
        <EditButton />
        <DeleteWithConfirmButton cancel="Cancel" undoable={true} />
      </Datagrid>
    </List>
  )
}

export default WsCampaignList
